export default __webpack_public_path__ + "static/media/Hoshang_Shahs_Tomb_01.4675da5e.jpg";